import { ReportingPeriodOption } from '../models';

/**
 * Earliest reporting year the system has data for. The dropdown should never offer
 * anything older than this.
 */
const MIN_REPORTING_YEAR = 2026;

export const buildPeriod = (year: number): ReportingPeriodOption => ({
    year,
    startDate: new Date(Date.UTC(year, 0, 1)).toISOString(),
    endDate: new Date(Date.UTC(year, 11, 31, 23, 59, 59)).toISOString(),
    label: String(year),
});

/**
 * Returns one option per year from the 2026 floor up through the current year, newest
 * first. Empty when "now" is before the floor.
 */
export const buildAvailablePeriods = (now: Date = new Date()): ReportingPeriodOption[] => {
    const currentYear = now.getUTCFullYear();
    if (currentYear < MIN_REPORTING_YEAR) {
        return [];
    }
    const result: ReportingPeriodOption[] = [];
    for (let year = currentYear; year >= MIN_REPORTING_YEAR; year--) {
        result.push(buildPeriod(year));
    }
    return result;
};

export const periodKey = (p: ReportingPeriodOption): string => String(p.year);
